import { render, staticRenderFns } from "./SectionTableAndAddPharmacies.vue?vue&type=template&id=922c6110&"
import script from "./SectionTableAndAddPharmacies.vue?vue&type=script&lang=js&"
export * from "./SectionTableAndAddPharmacies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports